import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { HyperLinkMenu } from "@models/hyperLinkMenu";
import { deleteRequest, fetchRequest } from "@actions/hyperLinkMenu";
import HyperLinkMenuForm from "@components/hyperLinkMenus/Form";
import { createRequest, updateRequest } from "@actions/hyperLinkMenu";
import hyperLinkMenuApi from "@api/hyperLinkMenu";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: HyperLinkMenu[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class HyperLinkMenuFormPage extends React.Component<AllProps> {
  state = {
    hyperLinkMenu: null,
    hyperLinkMenu_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.hyperLinkMenu_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    hyperLinkMenuApi
      .getItem({
        params: {
          id: this.state.hyperLinkMenu_id
        }
      })
      .then(({ data }) => {
        this.setState({
          hyperLinkMenu: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.hyperLinkMenu_id && !this.state.hyperLinkMenu) {
      return null;
    }

    return (
      <HyperLinkMenuForm
        hyperLinkMenu={this.state.hyperLinkMenu}
        intl={this.props.intl}
        listUrl={"/hyperLinkMenus"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ hyperLinkMenus }: ApplicationState) => ({
  loading: hyperLinkMenus.loading,
  errors: hyperLinkMenus.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(HyperLinkMenuFormPage));
